@if (procedure) {
  @if (showDetails) {
    <div class="header">
      <div class="title-item">
        <div class="procedure-title"> {{ procedure.titre }}</div>
        <div class="version">
          Version : {{ procedure.version }}
        </div>
      </div>
      <div class="additional-infos-items">
        <div> {{ procedure.category.libelle }}</div>
        <div>
          <mat-chip class="mat-chip" [ngClass]="
          {
            'en-application': procedure.etat.libelle === 'En application',
            'archive': procedure.etat.libelle === 'Archivé',
            'en-attente': procedure.etat.libelle === 'En attente d\'activation'
          }
          ">
            <span class="libelle">{{ procedure.etat.libelle }}</span>

          </mat-chip>
        </div>
      </div>
    </div>
  }
}
<div #logigramme_container class="logigramme-paper-container">
  <div class="toolbar-container display-none"></div>
  <div class="paper-container"></div>
  <div class="navigator-container display-none"></div>
</div>



